import LayerKeys from '~/config/layerKeys'

const RENDER_ORDER: Partial<Record<LayerKeys | 'GRID', number>> = {
  ROOFS: 2,
  ROOF_SECTIONS: 1,
  BACKGROUND_IMAGE: -1,
  EXTERIOR_WALLS: -2,
  GRID: -3,
}

export const getRenderOrder = (key: LayerKeys | 'GRID') => {
  return RENDER_ORDER[key] ?? 0
}
